import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router";
import { connect } from "react-redux";

const UserRoutePortfolio = ({ isAuthenticated, isPortfolio , layout:Layout,isConfirmed , component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated && isPortfolio && isConfirmed ? 
      <Layout>
        <Component {...props} />
      </Layout>
      : 
      !isConfirmed ?  <Redirect to="/confirmaccount" /> :
      <Redirect to="/" />
    }
  />
);
UserRoutePortfolio.propTypes = {
  component: PropTypes.any.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};
function mapStateToProps(state) {
  return {
    isAuthenticated: state.login.isAuthenticated,
    isConfirmed: state.login.isConfirmed,
    isPortfolio: state.login.user.roles.includes("Manufacturer") ||
                state.login.user.roles.includes("Installer") ||
                state.login.user.roles.includes("Designer"),
  };
}

export default connect(mapStateToProps)(UserRoutePortfolio);
